import React from "react";

const CardOneLineContent = ({ appName, content }) => {
  return (
    <div className="p-3">
      <div className="truncate-1-lines text-black text-lg font-bold my-2">{appName}</div>
      <div className="truncate-2-lines text-333 text-sm mb-3">
        <div dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    </div>
  );
};

export default CardOneLineContent;
